import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Asset } from "../../../../types/types";

const initialSelectedAsset: Asset = {

  name: "USDC Coin",
  code: "USDC",
  display_code: "USDC",
  symbol: "$",
  home_domain: "test-kado-anchor-sep.kado.money",
  icon: "/assets/img/token/us.svg",
  identifier: "USDC:GBBD47IF6LWK7P7MDEVSCWR7DPUWV3NY3DTQEVFL4NAT4AQH3ZLLFLA5",
  type: "fiat",
  issuer_name: "centre.io",
  issuer_terms: "centre.io/usdc",
  buy_enabled: false,
  sell_enabled: false,
  providers: {
    "buy": ["onramper"],
    "sell": ["onramper"]
  },
  // buy_enabled_moonpay:false,
  // sell_enabled_moonpay:false,
  deposit_enabled: false,
  withdraw_enabled: false,
  buy_sell_provider: "moonpay",
  sep6_deposit_type: "",
  deposit_withdraw_note: "This address only accepts USDC coming from another Stellar address and not from another blockchain network",
  decimal_places: 2,
  sep_31: false,
  sep_24: false,
  coingecko_id: "usd-coin",
  description: {
    en: "USD Coin (USDC) is a digital dollar, also known as a stablecoin. Every unit of this digital dollar in circulation is backed up by $1 that is held in reserve by financial institutions in the United States.",
    es: "USD Coin (USDC) es un dólar digital, también conocido como moneda estable. Cada unidad de este dólar digital en circulación está respaldada por 1 dólar que las instituciones financieras de Estados Unidos mantienen en reserva.",
    website: "https://www.centre.io/usdc",
    whitepaper: "https://f.hubspotusercontent30.net/hubfs/9304636/PDF/centre-whitepaper.pdf"

  },
  convert_to_cash: false,
  topups_enabled: true,
  sponsor_trust_line: true,
  remittances_enabled: true,
  trade_enabled: true
}

const initialState = initialSelectedAsset

const selectedAssetSlice = createSlice({
  name: 'selected-asset',
  initialState,
  reducers: {

    setSelectedAsset: (state, action: PayloadAction<Asset>) => {

      return (state = action.payload)

    },
    resetSelectedAsset: (state) => {

      return (state = initialState)

    },

  }

});

// Reducer
export default selectedAssetSlice.reducer;

// Actions
export const { setSelectedAsset, resetSelectedAsset } = selectedAssetSlice.actions;